import dynamic from "next/dynamic";

export const Embedded = dynamic(() => import("./component"));
